import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { KeyValueService } from '../key-value-service/key-value.service';

@Component({
  selector: 'app-key-value-add',
  templateUrl: './key-value-add.component.html',
  styleUrls: ['./key-value-add.component.scss']
})
export class KeyValueAddComponent implements OnInit {

  itemForm = new FormGroup({
    key: new FormControl(null, Validators.required),
    value: new FormControl(null, Validators.required)
  });

  constructor(private keyvalueService: KeyValueService) { }

  ngOnInit() {
  }

  public add() {
    this.keyvalueService.addItem({ key: this.itemForm.get('key').value, value: this.itemForm.get('value').value });
    this.itemForm.reset();
  }

}
